<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <!-- <li>
            <a href="#">
              About Us
            </a>
          </li> -->
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://www.vsds.sk/" target="_blank"
          >VSD a.s.</a>  v1.0.3
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
